import { Menu, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AuthUser from "../../Hooks/authUser";

const UserDashboardHeader = () => {
  const { userInfo, logout } = AuthUser();
  
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#291D89]/10 text-[#291D89] font-extrabold text-sm border border-[#291D89]/20 hover:bg-[#291D89]/20 transition-all duration-200 focus:outline-none">
          {userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : "P"}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2.5 w-56 origin-top-right divide-y divide-slate-100 rounded-xl bg-white shadow-lg border border-slate-100 focus:outline-none z-50">
          <div className="px-1.5 py-1.5 space-y-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="editProfile"
                  className={`${
                    active
                      ? "bg-secondary text-white"
                      : "text-slate-700"
                  } group flex w-full items-center rounded-lg px-3.5 py-2.5 text-xs font-semibold gap-2.5 transition duration-150`}
                >
                  <Icon className="text-base" icon="solar:user-bold" />
                  <span>Edit Profile</span>
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="changePassword"
                  className={`${
                    active
                      ? "bg-secondary text-white"
                      : "text-slate-700"
                  } group flex w-full items-center rounded-lg px-3.5 py-2.5 text-xs font-semibold gap-2.5 transition duration-150`}
                >
                  <Icon
                    className="text-base"
                    icon="solar:lock-keyhole-minimalistic-bold"
                  />
                  <span>Change Password</span>
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={logout}
                  className={`${
                    active
                      ? "bg-rose-500 text-white"
                      : "text-rose-500 hover:bg-rose-50"
                  } group flex w-full items-center rounded-lg px-3.5 py-2.5 text-xs font-semibold gap-2.5 transition duration-150`}
                >
                  <Icon className="text-base" icon="solar:logout-bold" />
                  <span>Log Out</span>
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default UserDashboardHeader;
